import "../../../index.css";
import { useState, useEffect } from "react";

import {
  Box,
  Grid,
  Button,
  Typography,
  Stepper,
  Step,
} from "@mui/material";
import {
  KeyboardArrowLeft as KeyboardArrowLeftIcon,
  NavigateNext as NavigateNextIcon,
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  CancelPresentation as CancelPresentationIcon,
} from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router-dom";
import { useDialogueState } from "../../../Context/DialogueProvider";
import CustomStepLabel from "../../StyledComponents/CustomStepLabel";
import CustomStepIcon from "../../StyledComponents/CustomStepIcon";
import CustomStepConnector from "../../StyledComponents/CustomStepConnector";
import RoomMasterFormOne from "./RoomMasterFormOne";
import RoomMasterFormTwo from "./RoomMasterFormTwo";
import { getFormMode } from "../../../lib/helpers";
import {
  getRoomMst,
  insertRoomFacLink,
  insertRoomMst,
  ManageRoomFacLink,
  retriveRoomFacLink,
  updateRoomMst,
} from "../../../Api/RoomMst/Api";
import { toast } from "react-toastify";
import { z } from "zod";
import axiosInstance from "../../../lib/axios";
import CrudButtons from '../../../../src/GlobalFunction/CrudButtons'
import { useTrackVisit } from '../../../hooks/useTrackVisit';
// import { useModulePermissions } from '../../../../src//GlobalFunction/useModulePermissions';

import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';

const formOneSchema = z.object({
  property: z.number(),
  wing: z.number(),
  floor: z.number(),
  roomType: z.number(),
  roomNo: z.string().min(1, "Room number cannot be empty"),
  sqft: z.string().transform((s) => parseInt(s, 10)),
  totalBeds: z.string().transform((s) => parseInt(s, 10)),
  monthlyRent: z.string().transform((s) => parseInt(s, 10)),
});

const steps = ["Room Details", "Facility Configuration"];
const DEFAULT_VALUES = {
  property: "",
  wing: "",
  floor: "",
  roomType: "",
  roomNo: "",
  sqft: "",
  totalBeds: "",
  monthlyRent: "",
};

const Form_Mode = getFormMode();

const RoomMaster = () => {

  const UserId = sessionStorage.getItem("UserId");
  const navigate = useNavigate();
  const location = useLocation();
  const [currentId, setCurrentId] = useState(() => {
    return location?.state?.RoomId;
  });

  console.log('Room id data', currentId)

  // Form States
  const [form, setForm] = useState(DEFAULT_VALUES);
  const [form2, setForm2] = useState([]);
  const [imageFile, setImageFile] = useState(null);
  const { dialogueState, setDialogueState } = useDialogueState();
  // const [mode, setMode] = useState(() => location?.state?.RoomId ? Form_Mode.read: Form_Mode.add);
  const [mode, setMode] = useState(() =>
    location?.state?.RoomId ? Form_Mode.read : Form_Mode.add
  );
 
  const [activeStep, setActiveStep] = useState(0);
const { navigateAndTrack } = useTrackVisit("Room Master");
  const isFormDisabled = mode === Form_Mode.read;
  // const permissions = useModulePermissions("Room Master");

  const handleNext = () => {
    if (activeStep === steps.length - 1) {
      // If user is on the last step, call the submit handler
      handleSubmit();
    } else {
      if (activeStep === 0 && formOneSchema.safeParse(form).success === false) {
        return toast.info("Fill all required inputs correctly");
      }
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }
  };


  const handleBack = () => {
    if (activeStep > 0) {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
    }
  };

  const handleBackdata = async () => {
    if (location.state && location.state.RoomId) {
      await formOneSetter("P");
    }
  };

  const handleNextdata = async () => {
    if (location.state && location.state.RoomId) {
      await formOneSetter("N");
    }
  };

  const submitHandlerOne = async () => {
    const result = formOneSchema.safeParse(form);
  
    if (!result.success) {
      return toast.error("Please fill in all required inputs correctly.");
    }
  
    const { data } = result;
  
    try {
      // Create FormData object
      const formData = new FormData();

      formData.append("RoomId", currentId ?? 0);
      formData.append("RoomNo", data.roomNo);
      formData.append("PropId", data.property);
      formData.append("WingId", data.wing);
      formData.append("FloorId", data.floor);
      formData.append("RoomTypeId", data.roomType);
      formData.append("SqFt", data.sqft || 0);
      formData.append("RoomViewId", 1);
      formData.append("TotalBeds", data.totalBeds || 0);
      formData.append("MonthlyRent", data.monthlyRent || 0);
      formData.append("Status", "1");
      formData.append("Remark", "api test");
      // formData.append("CreatedBy", "1");

      if (imageFile) {
        formData.append("imageFiles", imageFile);
      }

      const response = currentId
        ? await updateRoomMst(formData) 
        : await insertRoomMst(formData); 
  
      // Process response
      if (response.data.Status === 0) {
        toast.success(response.data.Message);
  
        // If insert, update `currentId` with the returned RoomId
        if (!currentId && response.data.Data && response.data.Data.RoomId) {
          setCurrentId(response.data.Data.RoomId);
        }

        navigate("/room-master");
      } else {
        toast.error(response.data.Message);
      }
    } catch (error) {
      console.error("Error in submitHandlerOne:", error);
      toast.error("Error: Could not submit Room data");
    }
  };


  const submitHandlerTwo = async () => {
    const data = form2.map(obj => ({
      RoomId: currentId ?? 1,
      FacilityId: obj.FacilityId,
      RoomFacId: obj.RoomFacId,
      Status: 1,
      Remark: obj.Remark,
      CreatedBy: 1,
    }))

    let payload = {
      RoomFacLinkConfig: data
    }

    let json = JSON.stringify(payload);

    json = json
      .replace(/\\/g, "\\\\")
      .replace(/"/g, '\\"');
    json = '"' + json + '"';

    const response = await ManageRoomFacLink(json);
    if (response instanceof Error) {
      return toast.error("Error: cannot submit facility data")
    }
    const {
      data: { Status, Message },
    } = response;


  };



  const handleSubmit = async () => {
    try {

      await submitHandlerOne();

      await submitHandlerTwo();
      setActiveStep(0);
      setMode(Form_Mode.read);

    } catch (error) {

      console.error("Error in handleSubmit:", error);
      toast.error("Error submitting data.");
    }
  };


  const handleAdd = () => {
    setForm(DEFAULT_VALUES);
    setMode(Form_Mode.add);
    console.log("Mode set to add");
  };



  const handleCancel = async () => {
    const response = await getRoomMst({
      RoomId: 1,
      Flag: "L",
    });

    if (response instanceof Error) {
      return toast.error("Error: could not fetch last record");
    }

    const {
      data: { Status, Data, Message },
    } = response;

    if (Status === 0 && Data && Data.length > 0) {
      // Set form data with the last record
      setForm({
        property: Data[0].PropId,
        wing: Data[0].WingId,
        floor: Data[0].FloorId,
        roomType: Data[0].RoomTypeId,
        roomNo: Data[0].RoomNo,
        sqft: Data[0]?.SqFt?.toString() ?? "0",
        totalBeds: Data[0].TotalBeds.toString(),
        monthlyRent: Data[0].MonthlyRent.toString(),
      });

      // Update currentId and reset mode
      setCurrentId(Data[0].RoomId);
      setMode(Form_Mode.read);
      setActiveStep(0);


    } else {
      console.log(Message);
      toast.error("No record found");
    }
  };

  const handleDelete = async () => {
    const response = await getRoomMst({ Flag: "D", RoomId: currentId });

    if (response instanceof Error) {
      return toast.error("Error: could not delete room");
    }

    const {
      data: { Status, Message, responseStatusCode },
    } = response;
    if (Status === 0 && responseStatusCode === 1) {
      toast.success(Message);
    } else {
      toast.error(Message);
    }
  };

  const handleExit = () => {
    navigateAndTrack("/room-master-table");
  };

  async function formOneSetter(flag = "R") {
    const response = await getRoomMst({
      RoomId: currentId,
      Flag: flag,
    });
    if (response instanceof Error) {
      toast.error("Error: Could not get room data");
    }

    const {
      data: { Status, Data, Message },
    } = response;

    console.log("RetrieveData123", Data);

    if (Status === 0) {
      setForm({
        property: Data[0].PropId,
        wing: Data[0].WingId,
        floor: Data[0].FloorId,
        roomType: Data[0].RoomTypeId,
        roomNo: Data[0].RoomNo,
        sqft: Data[0]?.SqFt?.toString() ?? "0",
        imageFiles: Data[0].RoomImage,
        totalBeds: Data[0].TotalBeds.toString(),
        monthlyRent: Data[0].MonthlyRent.toString(),
      });
      setCurrentId(() => Data[0]?.RoomId);
    }
    console.log("RetrieveData:", Data[0].RoomImage);
  }

  async function formTwoSetter(flag = "R") {
    const response = await retriveRoomFacLink({
      RoomId: currentId,
      Flag: flag,
    });
    if (response instanceof Error) {
      return toast.error("Error: could not get Facility data");
    }
    const {
      data: { Status, Data, Message },
    } = response;
    if (Status === 0) {
      toast.success(Message)
      const newFormattedData = Data.map(obj => ({
        FacilityName: obj.FacName,
        FacilityId: obj.FacilityId,
        RoomFacId: obj.RoomFacId,
        Status: 1,
        Remark: obj.Remark,
        CreatedBy: 1,
      }))
      setForm2(newFormattedData);
    } else {
      setForm2([])
    }
  }

  // FORM SETTER 
  useEffect(() => {
    if (location.state && location.state.RoomId) {
      formOneSetter();
      formTwoSetter();
    }
  }, [location.state]);



  const handleEdit = async () => {

    if (!UserId) {
      toast.error("Error: UserId is missing in session");
      return;
    }
    try {
      // First
      let getLockDataResponse = await axiosInstance.post("Lock/GetLockData", {
        tblName: "MstRoom",
        ColName1: "LockId",
        Cwhere: "RoomId",
        LockId: 0,
        DocId: currentId,
        UserID: parseInt(UserId, 10),
      });

      if (getLockDataResponse.data.Status === 0) {
        try {
          // Second
          let updateLockResponse = await axiosInstance.post("Lock/UpdateLock", {
            tblName: "MstRoom",
            LockSt: "1",
            LockId: parseInt(UserId, 10),
            Cwhere: "RoomId",
            LockDt: "2024-11-27 17:30:01.743",
            DocId: currentId,
            Flag: "",
            ColName: "LockSt",
            ColName1: "LockId",
            ColName2: "LockDt",
          });

          if (updateLockResponse.data.Status === 0) {
            setMode("edit");
            // setIsFormDisabled(false);
          } else {
            toast.info(updateLockResponse.data.Message, { autoClose: 1000 });
            console.log(updateLockResponse.data.Message);
          }
        } catch (err) {
          toast.error("Error updating lock data. Please try again later.", {
            autoClose: 1000,
          });
        }
      } else {
        setMode("view");
        toast.info(getLockDataResponse.data.Message, { autoClose: 1000 });
      }
    } catch (err) {
      toast.error("Error fetching lock data. Please try again later.", {
        autoClose: 1000,
      });
    }
  };
  
  const handleImageUpload = (file) => {
    setImageFile(file);
  };

  const RenderStepContent = (step) => {
    return (
      <Box sx={{ height: "350px", overflowY: "scroll", padding: "16px" }}>

        {(() => {
          switch (step) {
            case 0:
              return (
                <RoomMasterFormOne
                  formMode={mode}
                  form={form}
                  setForm={setForm}
                  onImageUpload={handleImageUpload}

                />
              );
            case 1:
              return (
                <RoomMasterFormTwo
                  form={form2}
                  setForm={setForm2}
                  formMode={mode}
                />
              );
          }
        })()}
      </Box>
    );
  };
  const handleStepClick = (step) => {
    if (mode === "view" || "add") {
      setActiveStep(step);
    }
  };

  return (
    <Grid>
      {/* <ToastContainer /> */}
      <Box className="form-container">
        <Grid container spacing={2} className="rasidant_grid">
          <Grid
            item
            xs={12}
            className="form_title"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginTop: "20px",
            }}
          >
            <Grid>
              <Button
                variant="contained"
                size="small"
                className="three-d-button-previous"
                onClick={handleBackdata}
                disabled={activeStep > steps.length}
              >
                <KeyboardArrowLeftIcon />
              </Button>
              <Button
                variant="contained"
                size="small"
                className="three-d-button-next"
                sx={{ margin: "0px 10px" }}
                onClick={handleNextdata}
                disabled={activeStep > steps.length}
              >
                <NavigateNextIcon />
              </Button>
            </Grid>
            <Typography variant="h5">Room Master</Typography>

            <Grid sx={{ display: "flex", justifyContent: "end" }}>
              <CrudButtons
                moduleName="Room Master"
                mode={mode}
                onAdd={handleAdd}
                onEdit={handleEdit}
                onDelete={handleDelete}
                onExit={handleExit}
                readOnlyMode={mode === Form_Mode.read}
              />
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Stepper
              activeStep={activeStep}
              connector={<CustomStepConnector />}
              alternativeLabel
            >
              {steps.map((label, index) => (
                <Step
                  key={label}
                  onClick={() => handleStepClick(index)}
                  style={{
                    cursor: mode === "view" || "add" ? "pointer" : "default",
                  }}
                >
                  <CustomStepLabel
                    StepIconComponent={(props) => (
                      <CustomStepIcon
                        ownerState={{ ...props, active: activeStep === index }}
                      >
                        {index + 1}
                      </CustomStepIcon>
                    )}
                  >
                    {label}
                  </CustomStepLabel>
                </Step>
              ))}
            </Stepper>
          </Grid>

          <Grid item xs={12}>
            {RenderStepContent(activeStep)}
          </Grid>

          <Grid item xs={12} className="form_button">
            <Button
              variant="contained"
              size="small"
              // sx={{ backgroundColor: '#635bff', mr: 1 }}
              sx={{
                mr: 1,
                background: "linear-gradient(290deg, #b9d0e9, #e9f2fa)",
              }}
              onClick={handleBack}
            // disabled={activeStep === 0 || mode !== Form_Mode.read}
            >
              {activeStep === steps.length - 1 ? "Previous" : "Previous"}
              {/* Previous */}
            </Button>
            <Button
              variant="contained"
              onClick={handleNext}
              sx={{
                mr: 1,
                background: "linear-gradient(290deg, #d4d4d4, #d4d4d4)",
              }}
              disabled={mode === Form_Mode.read}
            >
              {activeStep === steps.length - 1 ? "Submit" : "Next"}
            </Button>
            <Button
              variant="contained"
              onClick={handleCancel}
              // sx={{ mr: 1 }}
              sx={{
                mr: 1,
                background: "linear-gradient(290deg, #b9d0e9, #e9f2fa)",
              }}
            >
              Cancel
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Grid>
  );
};

export default RoomMaster;